<template>
  <div id="AddSemesterDialog" class="wrap" >
    <v-app-bar extended extension-height="10" class="grey lighten-3 hidden-md-and-up"  fixed  elevate-on-scroll  >
      <v-layout column align-center class="justify-center">
        <span class="title light-blue--text text--darken-3 text-center">Edit Semester</span>
        <v-layout row align-baseline class=" ">
            <span class="subheading ">{{semester.semester_academic_status}} Year </span>
            <span class=" subheading ml-1  ">{{semester.semester_term}}</span>
            <span class=" ml-1  ">{{semester.semester_year | moment("YYYY")}}</span>
          </v-layout>
      </v-layout>
    </v-app-bar>
    <div class="maxContainer">
      <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8">
        <div @click="back" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
      </div>
      <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8">
        <v-card class=" mb-5 pt-5" flat  >

          <v-card-text class="mt-0 pt-0 px-0">

          <v-container grid-list-md pt-0>

            <v-form wrap>
              <v-layout column align-center class="justify-center hidden-sm-and-down mb-3">
                <span class="headline light-blue--text text--darken-3 text-center">Edit Semester</span>
                <v-layout row align-baseline class=" ">
                    <span class="subheading ">{{semester.semester_academic_status}} Year </span>
                    <span class=" subheading ml-1  ">{{semester.semester_term}}</span>
                    <span class=" ml-1  ">{{semester.semester_year | moment("YYYY")}}</span>
                  </v-layout>
              </v-layout>

              <!-- Semester Completion Status -->
              <v-flex xs12>
                <v-select
                  v-model="semester.semester_completion_status"
                  :items="['In Progress', 'Completed', 'Planned']"
                  label="Completion Status"
                  required
                  outlined

                ></v-select>
              </v-flex>
              <!-- Semester  Academic Status-->
              <v-flex xs12>
                <v-select
                  v-model="semester.semester_academic_status"
                  :items="['Freshman', 'Sophomore', 'Junior', 'Senior']"
                  label="Academic Status"
                  required
                  outlined

                ></v-select>
              </v-flex>
              <!-- Semester Term-->
              <v-flex xs12>
                <v-select
                  v-model="semester.semester_term"
                  :items="['Fall', 'Winter', 'Spring', 'Summer', 'Summer 1', 'Summer 2', 'International']"
                  label="Semester Term"
                  required
                  outlined

                ></v-select>
              </v-flex>
              <!-- Semester Start Date -->

              <v-flex  class="mt-0 pt-0" xs12>
                <v-menu
                  ref="menu3"
                  :close-on-content-click="false"
                  v-model="menu3"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                  <v-text-field
                    slot="activator"
                    :value="computedSemesterStartDateFormattedMomentjs"
                    label="Start Date"
                    prepend-inner-icon="mdi-calendar"
                    clearable
                    outlined
                    v-on="on"
                  ></v-text-field>
                   </template>
                  <v-date-picker v-model="semester.semester_year" no-title @input="menu3 = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-form>
            <!-- Add Semester Button -->
          <v-layout row class="mt-2 mb-3">
            <v-btn
              color="green"
              @click="editSemester()"
              block
              depressed

              large
            >
              <span class="white--text"> Save</span>
            </v-btn>
          </v-layout>
          </v-container>

          </v-card-text>
          <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click.native="EditSemesterDialog = false">Close</v-btn>
          <v-btn color="blue darken-1" outline flat @click.native="editSemester()">Save</v-btn>
        </v-card-actions>
          <div style="flex: 1 1 auto;"></div> -->
        </v-card>
      </div>
    </div>
        <!-- Back Button -->
        <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>

  </div>

</template>

<script>
  import moment from 'moment'
  export default {
     data() {
      return {
        modal: false,
        alert: false,
        menu3: false,
        EditSemesterDialog : false,
      }
    },
    methods: {
      back() {
        this.$router.go(-1)
      },
      showEditSemester(user) {
        if(user !== null && user !== undefined ){
          this.EditSemesterDialog = true
        }
        else {
          this.alert = true
        }
      },
      editSemester () {
        const semesterData = {
          semester_term : this.semester.semester_term,
          semester_academic_status: this.semester.semester_academic_status,
          semester_year: this.semester.semester_year,
          semester_completion_status: this.semester.semester_completion_status,
          semesterId: this.semester.id,
          collegeId: this.college.id,
        }
        this.EditSemesterDialog = false
        this.$store.dispatch('setEditUserSemester', semesterData)
        this.$router.go(-1)
      }
    },
    computed : {
      collegeId () {
        return this.$route.params.collegeId
      },
      semesterId () {
        return this.$route.params.semesterId
      },
      user () {
        return this.$store.getters.user
      },
      college() {
      return this.$store.getters.loadedCollege(this.collegeId);
      },
     semester() {
       return this.college.semesters.find((semester) => {
          return semester.id === this.semesterId
        })
     },
     computedSemesterStartDateFormattedMomentjs () {
       return this.semester.semester_year ? moment(this.semester.semester_year).format('MM/DD/YYYY') : ''
     }
    },
  }
</script>

<style scoped>
 #headerToolbar {
    position: sticky;
    box-shadow: 0 10px 30px -10px #11111130;
  }

  .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.wrap {
  margin-top: 8vh !important;  
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Semesters/EditSemesterDialog.vue